import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../utils/api';

const PrintPunishment = () => {
    const { id } = useParams();
    const [warning, setWarning] = useState(null);

    useEffect(() => {
        const fetchWarning = async () => {
            try {
                const response = await api.get(`/warnings`);
                const allWarnings = response.data;
                const currentWarning = allWarnings.find(w => w.id === parseInt(id));
                setWarning(currentWarning);
            } catch (error) {
                console.error("Error fetching warning:", error);
            }
        };
        fetchWarning();
    }, [id]);

    useEffect(() => {
        if (warning) {
            const timer = setTimeout(() => {
                window.print();
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [warning]);

    if (!warning) return <div className="text-center p-10 font-cairo">جاري تحميل البيانات...</div>;

    const student = warning.student || {};
    const date = new Date(warning.created_at).toLocaleDateString('ar-MA');
    
    // Format dates for display
    const startDate = warning.punishment_start_date ? new Date(warning.punishment_start_date).toLocaleDateString('ar-MA') : '...../......./........';
    const endDate = warning.punishment_end_date ? new Date(warning.punishment_end_date).toLocaleDateString('ar-MA') : '...../......./........';

    return (
        <div className="print-container">
            <div className="header-section flex justify-between items-start mb-4">
                <div className="text-right leading-tight text-sm font-bold">
                    <div>المملكة المغربية</div>
                    <div>جمعية تنمية النقل المدرسي أولاد دحو</div>
                </div>
            </div>

            <div className="text-center mb-6">
                <h1 className="text-2xl font-bold underline mb-4">قرار تأديبي بمنع الاستفادة من خدمة النقل المدرسي</h1>
                <div className="flex justify-between items-center text-sm font-bold px-4 mb-4">
                    <div>رقم المرجع: {warning.id}/{new Date().getFullYear()}</div>
                    <div>التاريخ: {date}</div>
                </div>
            </div>

            <div className="info-section text-sm font-bold leading-relaxed mb-6 pr-4">
                <div>إلى السيد(ة): {student.parent_name || '..............................................'}</div>
                <div>ولي أمر التلميذ(ة): {student.full_name || '..............................................'}</div>
                <div>القسم: {student.school_class?.name || '..............................................'}</div>
            </div>

            <div className="content-section text-sm leading-8 font-medium">
                <div className="font-bold mb-4">الموضوع: إشعار بعقوبة تأديبية</div>
                
                <div className="mb-4">سلام تام بوجود مولانا الإمام،</div>
                
                <div className="mb-4 text-justify">
                    تبعاً للمخالفات المسجلة في حق ابنكم/ابنتكم والمتعلقة بعدم احترام النظام الداخلي للنقل المدرسي، وبعد استنفاد الإجراءات التربوية المتمثلة في التنبيه والإنذار، تقرر اتخاذ الإجراء التأديبي التالي:
                </div>

                <div className="font-bold text-lg text-center mb-4 mt-4 leading-relaxed px-4">
                    منع التلميذ(ة) من ركوب حافلة النقل المدرسي لمدة: <span className="underline">{warning.punishment_days || '.........'} أيام</span>، 
                    ابتداءً من: <span className="underline">{startDate}</span> إلى غاية : <span className="underline">{endDate}</span>
                </div>

                <div className="mb-2 font-bold">سبب العقوبة:</div>
                <div className="bg-slate-50 border border-dashed border-slate-300 p-4 rounded-lg mb-4 min-h-[60px] text-justify font-bold">
                    {warning.reason}
                </div>

                <div className="mb-6 text-justify">
                    ويأتي هذا القرار حفاظاً على سلامة التلاميذ وضمان حسن سير خدمة النقل المدرسي، مع التأكيد على أن التلميذ(ة) يمكنه استئناف الاستفادة من الخدمة بعد انتهاء مدة العقوبة، شريطة الالتزام الكامل بقواعد الانضباط واحترام النظام الداخلي.
                </div>

                <div className="mb-4">يرجى منكم الاطلاع على هذا الإشعار والتوقيع عليه بما يفيد العلم.</div>

                <div className="mb-6">وتفضلوا بقبول فائق عبارات التقدير والاحترام.</div>
            </div>

            <div className="footer-section mt-6 flex justify-between items-start text-sm font-bold px-10">
                <div className="text-center">
                    <div className="mb-6 text-lg">توقيع التلميد / الولي</div>
                </div>
                <div className="text-center">
                    <div className="mb-6 text-lg">ادارة الجمعية</div>
                    <div className="text-right">
                        <div className="mb-6">الاسم: ............................................</div>
                        <div>التوقيع والختم: .....................................</div>
                    </div>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
                
                html, body {
                    margin: 0;
                    padding: 0;
                    background: white;
                    height: 100%;
                }

                .print-container {
                    width: 210mm;
                    max-height: 290mm;
                    padding: 8mm 12mm;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Cairo', sans-serif;
                    color: #000;
                    background: #fff;
                    box-sizing: border-box;
                }

                @media print {
                    @page { 
                        margin: 0; 
                        size: A4 portrait; 
                    }
                    html, body { 
                        background: none; 
                        height: 100%;
                        overflow: hidden;
                    }
                    .print-container { 
                        width: 100%;
                        height: 100vh;
                        max-height: 285mm;
                        padding: 6mm 12mm; 
                        margin: 0;
                        box-shadow: none;
                        page-break-after: avoid;
                        page-break-inside: avoid;
                    }
                    .border-dashed {
                        border-style: solid !important;
                    }
                }
            `}} />
        </div>
    );
};

export default PrintPunishment;
